import React, { useEffect } from 'react';

import { content, links } from '../../content';
import logo from '../../c1logo.png';
import equalHousing from '../../EqualHousing_logo.jpg';
import fdicSprite from '../../fdic.png';

import './MovedPage.css';

const LockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <rect x="4.5" y="10.5" width="15" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7.5 10.5V8a4.5 4.5 0 0 1 9 0v2.5" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="12" cy="14.5" r="1.25" fill="currentColor" />
    <path d="M12 15.5v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const MovedPage = ({ locale = 'en' }) => {
  const t = content[locale] || content.en;
  const year = new Date().getFullYear();

  useEffect(() => {
    document.documentElement.lang = t.htmlLang;
  }, [t.htmlLang]);

  return (
    <div className="app">
      <header className="sc-header">
        <a className="sc-header__logo" href={links.capitalOne}>
          <img src={logo} alt={t.logoAlt} />
        </a>
        <div className="sc-header__right">
          <a className="sc-header__toggle" href={t.toggleHref}>{t.toggleLabel}</a>
          <span className="sc-header__lock" role="img" aria-label={t.lockLabel}>
            <LockIcon />
          </span>
        </div>
      </header>

      <main className="sc-main">
        <h1 className="sc-main__heading">{t.heading}</h1>
        <p className="sc-main__body">{t.body}</p>
      </main>

      <footer className="sc-footer">
        <div className="sc-footer__legal">
          <a href={links.privacy}>{t.privacy}</a>
          <a href={links.security}>{t.security}</a>
          <a href={links.terms}>{t.terms}</a>
        </div>
        <div className="sc-footer__brand">
          <div className="sc-footer__brand-left">
            <a href={links.capitalOne}>
              <img className="sc-footer__logo" src={logo} alt={t.logoAlt} />
            </a>
            <span className="sc-footer__copyright">©{year} Capital One</span>
          </div>
          <div className="sc-footer__brand-right">
            <a
              className="sc-footer__fdic"
              href={links.fdic}
              aria-label={t.fdicLabel}
              style={{ backgroundImage: `url(${fdicSprite})` }}
            >
              {' '}
            </a>
            <img className="sc-footer__eqhousing" src={equalHousing} alt={t.equalHousing} />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MovedPage;
